module.exports = __webpack_public_path__ + "static/img/img-figer-01.d769d50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img-figer-01.png
// module id = JIxd
// module chunks = 1